const API_BASE_URL = 'https://api.dev.auxo.dk';

/**
 * Henter alle sider fra CMS'et.
 * Da vi har under 25 sider, bruger vi det simple array-endpoint,
 * som altid returnerer alle elementer som et rent array.
 */
export async function fetchAllPages() {
  try {
    const response = await fetch(`${API_BASE_URL}/public/content/pages`);
    if (!response.ok) {
      throw new Error(`Kunne ikke hente sider: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Fejl ved hentning af sider fra CMS:', error);
    return [];
  }
}

/**
 * Henter alle gallerier fra CMS'et.
 */
export async function fetchAllGalleries() {
  try {
    const response = await fetch(`${API_BASE_URL}/public/content/gallery`);
    if (!response.ok) {
      throw new Error(`Kunne ikke hente gallerier: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Fejl ved hentning af gallerier fra CMS:', error);
    return [];
  }
}

/**
 * Henter et specifikt galleri baseret på dets gallery_slug.
 */
export async function fetchGalleryBySlug(slug) {
  try {
    // Vi bruger v2-endpointet med filter for at hente det specifikke galleri
    const response = await fetch(`${API_BASE_URL}/public/v2/content/gallery?gallery_slug=${slug}`);
    if (!response.ok) {
      throw new Error(`Kunne ikke hente galleri: ${response.statusText}`);
    }
    const data = await response.json();
    return data.items && data.items.length > 0 ? data.items[0] : null;
  } catch (error) {
    console.error(`Fejl ved hentning af galleri med slug ${slug}:`, error);
    return null;
  }
}
